export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11517.34914785.jpg";